"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _KYCBaseComponent = _interopRequireDefault(require("./KYCBaseComponent"));
var _kycLevelsSelectors = require("../../redux/selectors/kycLevelsSelectors");
var _userActions = require("../../redux/actions/userActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var kycData = (0, _kycLevelsSelectors.kycVerificationLevelsSelector)(state);
  var verificationLevel = kycData.verificationLevel,
    levelIncreaseStatus = kycData.levelIncreaseStatus,
    kycConfig = kycData.kycConfig;
  var highlightStyle = kycConfig.highlightStyle;
  return {
    verificationLevel: verificationLevel,
    levelIncreaseStatus: levelIncreaseStatus,
    kycConfig: kycConfig,
    highlightStyle: highlightStyle,
    userId: state.user.userInfo.UserId,
    userName: state.user.userInfo.UserName
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getUserConfig: function getUserConfig(userId, username) {
      return dispatch((0, _userActions.getUserConfig)(userId, username));
    }
  };
};
var KYCBaseContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_KYCBaseComponent["default"]);
var _default = exports["default"] = KYCBaseContainer;